import { SEND_INVOICE, SEND_INVOICES_BULK } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface SendInvoiceResponse {
  success: boolean;
  message?: string;
  data?: {
    sentTo: string;
    sentAt: string;
  };
}

interface BulkSendResult {
  invoiceId: string;
  invoiceNumber?: string;
  success: boolean;
  message: string;
}

interface SendInvoicesBulkResponse {
  success: boolean;
  message?: string;
  data?: {
    summary: { total: number; sent: number; failed: number };
    results: BulkSendResult[];
  };
}

const sendInvoiceApi = async (
  invoiceId: string,
  force = false,
  email?: string
): Promise<SendInvoiceResponse> => {
  try {
    const response = await makeAuthenticatedRequest(SEND_INVOICE(invoiceId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ force, ...(email && { email }) }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.message || `HTTP error! status: ${response.status}`
      );
    }

    return result;
  } catch (error) {
    console.error('Send invoice failed:', error);
    throw error;
  }
};

const sendInvoicesBulkApi = async (
  invoiceIds: string[]
): Promise<SendInvoicesBulkResponse> => {
  try {
    const response = await makeAuthenticatedRequest(SEND_INVOICES_BULK, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ invoiceIds }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.message || `HTTP error! status: ${response.status}`
      );
    }

    return result;
  } catch (error) {
    console.error('Bulk send invoices failed:', error);
    throw error;
  }
};

export {
  sendInvoiceApi,
  sendInvoicesBulkApi,
  type SendInvoiceResponse,
  type SendInvoicesBulkResponse,
  type BulkSendResult,
};
